export default function ExportApi({ makeRequest, buildRequest, baseUrl = '' }) {
    
    function createExport(date) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/export/documents/${date}`));
        });
    }

    function getExports(){
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/export`));
        });
    }

    function getCMSDocument(id) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/export/document/CMS/${id}`));
        });
    }

    function getFinanceDocument(id){
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/export/document/Finance/${id}`));
        });
    }

    function deleteExport(id){
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`${baseUrl}/export/${id}`));
        });
    }


    return {
        createExport,
        getExports,
        getCMSDocument,
        getFinanceDocument,
        deleteExport
    }

}